module.exports = __webpack_public_path__ + "img/Passport-vector-350x500.f2977cfa.jpg";